import React from 'react';
import { Loader } from 'pixi.js'
import {  Container, AnimatedSprite } from '@inlet/react-pixi'

let dolphinTextures = [];

const LearningDolphinAssetHolder = ({ _count }) => {

    const loader = Loader.shared;

    for (let i = 2; i <= 38; i++) {
        if (i < 21)
            dolphinTextures.push(loader.resources["./assets/images/components/island/spritesheets/seaAssets/dolphin1.json"].textures[`island-night_animated00${i}.png`]);
        else
            dolphinTextures.push(loader.resources["./assets/images/components/island/spritesheets/seaAssets/dolphin2.json"].textures[`island-night_animated00${i}.png`]);
    }

    return (
        <Container>
            {
                _count > 0 ?
                    <AnimatedSprite 
                        textures={dolphinTextures}
                        scale={{ x: 0.07, y: 0.07 }}
                        isPlaying={true}
                        initialFrame={0}
                        x={40}
                        y={-80}
                        animationSpeed={0.2}
                    />
                    : <></>

            }
            {
                _count > 1 ?
                    <AnimatedSprite
                        textures={dolphinTextures}
                        scale={{ x: 0.07, y: 0.07 }}
                        isPlaying={true}
                        initialFrame={0}
                        x={10}
                        y={-80}
                        animationSpeed={0.2}
                    />
                    : <></>

            }
            {
                _count > 2 ?
                    <AnimatedSprite
                        textures={dolphinTextures}
                        scale={{ x: 0.07, y: 0.07 }}
                        isPlaying={true}
                        initialFrame={28}
                        x={-80}
                        y={140}
                        animationSpeed={0.2}
                    />
                    : <></>
            }
            {
                _count > 3 ?
                    <AnimatedSprite
                        textures={dolphinTextures}
                        scale={{ x: 0.07, y: 0.07 }}
                        isPlaying={true}
                        initialFrame={28}
                        x={-110}
                        y={140}
                        animationSpeed={0.2}
                    />
                    : <></>
            }
            {
                _count > 4 ?
                    <AnimatedSprite
                        textures={dolphinTextures}
                        scale={{ x: 0.07, y: 0.07 }}
                        isPlaying={true}
                        initialFrame={28}
                        x={-140}
                        y={140}
                        animationSpeed={0.2}
                    />
                    : <></>
            }
        </Container>
    );
};

export { LearningDolphinAssetHolder as default }


